/**
 * Application Constants
 * Centralized configuration values for VGWS Care Desk
 */

// Polling and refresh intervals (in milliseconds)
export const POLLING_INTERVALS = {
  SLA_TIMER: 15000,           // 15 seconds - SLA countdown updates
  DASHBOARD_REFRESH: 30000,   // 30 seconds - Dashboard auto-refresh (reduced for 1000+ users)
  ANALYTICS_REFRESH: 45000,   // 45 seconds - Analytics data refresh (heavy queries)
  TICKET_LIST_REFRESH: 30000, // 30 seconds - Ticket list refresh
  RESOLVER_REFRESH: 30000,    // 30 seconds - Resolver dashboard refresh
};

// HTTP status codes
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

// SLA thresholds (in percentage)
export const SLA_THRESHOLDS = {
  WARNING: 75,   // Show warning when below 75%
  DANGER: 50,    // Show danger when below 50%
  CRITICAL: 25,  // Critical level
};

// Chart and visualization defaults
export const CHART_CONFIG = {
  MAX_ITEMS_DISPLAY: 70,     // Maximum items to show in charts
  DEFAULT_PAGE_SIZE: 10,     // Default pagination size
};

// Time constants (in hours)
export const TIME_CONSTANTS = {
  LEVEL1_ESCALATION_HOURS: 24,
  LEVEL2_ESCALATION_HOURS: 48,
  INACTIVE_THRESHOLD_HOURS: 48,
};

// Statuses that count as "Pending & Open" work on TR UI-1 (Process Owner
// Dashboard) — i.e. tickets still requiring resolver action. Terminal
// statuses (Resolved, Closed - Feedback Received, Duplicate Ticket,
// Completed, Ticket Closed) are deliberately excluded from this list so
// the "Pending Action" count reflects only actionable work.
export const PENDING_OPEN_STATUSES = [
  'Open',
  'Acknowledged',
  'In Progress',
  'SLA BREACHED',
  'On Leave',
  'Shift Completed',
  'Purchase Material Requested',
  'Purchase Material Approved',
  'Purchase Material Received',
  'Ticket Diverted',
  'Long Term Vacations',
];

// Terminal statuses — a ticket in any of these is considered DONE and
// must NEVER be counted under "Pending Action" tiles / "Open" filters.
export const TERMINAL_STATUSES = [
  'Resolved',
  'Completed',
  'Closed - Feedback Received',
  'Duplicate Ticket',
  'Ticket Closed',
];

// Fast membership helpers — exported as Sets to avoid re-allocating on
// every render tick when a dashboard has hundreds of tickets.
export const PENDING_OPEN_STATUS_SET = new Set(PENDING_OPEN_STATUSES);
export const TERMINAL_STATUS_SET = new Set(TERMINAL_STATUSES);

export const isPendingOpen = (ticket) =>
  PENDING_OPEN_STATUS_SET.has(ticket?.status);

export const isTerminal = (ticket) =>
  TERMINAL_STATUS_SET.has(ticket?.status);
